module.exports = __webpack_public_path__ + "img/ruoyi9.01a86bfe.png";